// extracted by mini-css-extract-plugin
module.exports = {"container":"Carousel_container__KPoSy","prevBtn":"Carousel_prevBtn__0lF2a","nextBtn":"Carousel_nextBtn__RrLLU","carouselItems":"Carousel_carouselItems__KysOg"};